import * as React from "react";
import styled, { css } from "styled-components";
import { useHistory } from "react-router-dom";
import * as moment from "moment-timezone";

import {
  BasicModal,
  BasicModalProps
} from "src/library/components/Modal";
import { Text } from "src/library/components/Text";
import { Button } from "src/library/components/Button";

import { Invoice } from "../../api/accounting.api";

interface PayInvoiceLaterWarningModalProps extends Omit<BasicModalProps, "title"> {
  invoice: Invoice;
}

const PayInvoiceLaterWarningModal: React.ReactFCWithChildren<PayInvoiceLaterWarningModalProps> = ({
  open,
  onDismiss,
  invoice
}) => {
  const history = useHistory();

  const dueDateFormatted = React.useMemo(() => {
    if (invoice.dueDate) {
      return ` by ${moment.utc(invoice.dueDate).format("DD MMMM YYYY")}`;
    }

    return "";
  }, [ invoice.dueDate ]);

  return (
    <BasicModal
      open={open}
      onDismiss={onDismiss}
      title="Confirm Pay Later"
      body=""
    >
      <StyledPayInvoiceLaterWarningModal>
        <div className="note">
          <Text>
            {`Payment for this invoice is required${dueDateFormatted}`}
          </Text>
        </div>

        <div className="note">
          <Text>
            {`By clicking confirm, you agree to pay for the invoice${dueDateFormatted}. Late payments may incur additional charges.`}
          </Text>
        </div>

        <div className="actions">
          <Button
            onClick={onDismiss}
            $buttonType="secondary"
          >
            Cancel
          </Button>

          <Button
            onClick={() => history.push(`/admin/accounting/invoices/${invoice.id}`)}
            $buttonType="primary"
          >
            Confirm
          </Button>
        </div>
      </StyledPayInvoiceLaterWarningModal>
    </BasicModal>
  );
};

export default PayInvoiceLaterWarningModal;

const StyledPayInvoiceLaterWarningModal = styled.div`
  ${({ theme }) => css`
    .note {
      margin: ${theme.spacing.margins.md} 0;
    }

    .actions {
      display: flex;
      justify-content: space-between;
      padding-top: ${theme.spacing.padding.lg};
    }
  `}
`;
